var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepbystep = function SvgStepbystep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC8F2",
    fillRule: "evenodd",
    d: "M12.5 10v13.5a1 1 0 0 0 1 1.001h10v4l4-4h2a1 1 0 0 0 1-1V10c0-.552-.447-1.002-1-1.002h-16c-.553 0-1 .45-1 1.001",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M9.5 25a.5.5 0 0 1-.354-.146L5.293 21H2.5c-.827 0-1.5-.673-1.5-1.5v-15C1 3.672 1.673 3 2.5 3h17c.827 0 1.5.673 1.5 1.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v15c0 .276.224.501.5.501h3a.5.5 0 0 1 .354.146L9 23.293V20.5A.5.5 0 0 1 9.5 20h10c.276 0 .5-.225.5-.5V9.5a.5.5 0 0 1 1 0v10c0 .827-.673 1.5-1.5 1.5H10v3.501a.5.5 0 0 1-.5.499",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M23.5 29.001a.497.497 0 0 1-.5-.5V25h-9.5a1.5 1.5 0 0 1-1.5-1.5v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 1 .5.501v2.792l3.146-3.147a.5.5 0 0 1 .354-.145h2a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-16a.5.5 0 0 0-.5.5V18.5a.5.5 0 1 1-1 0v-10c0-.827.673-1.5 1.5-1.5h16c.827 0 1.5.673 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-1.793l-3.854 3.853a.5.5 0 0 1-.353.148M9 17.5a.499.499 0 1 1-.998 0 .499.499 0 0 1 .998 0M7 17.5a.5.5 0 1 1-.998 0 .5.5 0 0 1 .998 0M5 17.5a.5.5 0 1 1-.998 0 .5.5 0 0 1 .998 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M28 21.5a.5.5 0 1 1-1.001 0 .5.5 0 0 1 1.001 0M26 21.5a.5.5 0 1 1-1.002 0 .5.5 0 0 1 1.002 0M24 21.5a.5.5 0 1 1-1.001 0 .5.5 0 0 1 1.001 0",
    clipRule: "evenodd"
  })));
};
export default SvgStepbystep;